import { Component, Prop, Host, h, Watch } from '@stencil/core';
import state from '@ugc-store';
import { qnaQuery } from '@ugc-graphql';
import { initDomains } from '@ugc-utils/domains';
import { initProductId, initProductInfo } from '@ugc-utils/product';
import { getVisitorId } from '@ugc-utils/fingerprint';
import ViewMobile from './view.mobile';
import ViewDesktop from './view.desktop';
import { ModuleType, setLoadTime } from '@ugc-utils/performance';

declare global {
  interface Window {
    dataLayer: any;
  }
}

@Component({
  tag: 'ugc-pdp-question-and-answer',
  styleUrl: 'ugc-pdp-question-and-answer.scss',
  shadow: false,
})
export class UgcPdpQuestionAndAnswer {
  @Prop({ reflect: true }) productId: number;
  @Prop({ reflect: true }) product?: string;

  initDomainAndProduct() {
    initDomains();
    if (state.isDesktop) {
      initProductId(this.productId);
    } else {
      initProductInfo(this.product);
    }
  }

  async componentWillLoad() {
    this.initDomainAndProduct();
    await getVisitorId();
  }

  @Watch('productId')
  async watchProductIdHandler() {
    this.initDomainAndProduct();
  }

  componentDidRender() {
    setLoadTime(ModuleType.qna);
  }

  render() {
    const { isDesktop } = state;

    return (
      <Host>
        <ugc-apollo query={qnaQuery} storeName="qnaStaticLanguage">
          {isDesktop ? <ViewDesktop productId={this.productId} /> : <ViewMobile productId={this.productId} />}
        </ugc-apollo>
      </Host>
    );
  }
}
